import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { RichText } from "@learningblocks/shared-components/lib/RichText";
import { injectIntl, FormattedMessage } from "react-intl";

class TakeawayMessagesBase extends React.Component {
  render() {
    const { intl } = this.props;
    return (
      <div
        className={this.props.className}
        style={{
          background: this.props.caption ? "white" : null,
          borderRadius: this.props.caption ? "5px" : null,
          border: this.props.caption ? "1px solid #ccd8e1" : null,
          paddingTop: this.props.caption ? "8px" : null,
        }}
        dir="auto"
      >
        {this.props.heading && (
          <h5
            style={{
              marginTop: this.props.description ? 16 : 0,
              marginLeft: this.props.caption ? "8px" : null,
            }}
          >
            <FormattedMessage
              id={this.props.heading}
              defaultMessage={this.props.heading}
              description=""
            />
          </h5>
        )}
        {this.props.description && (
          <div style={{ marginTop: this.props.heading ? 16 : 0 }}>
            <RichText text={this.props.description} />
          </div>
        )}
        <ul
          style={{
            marginTop: this.props.heading || this.props.description ? 16 : 0,
            padding: this.props.caption ? "0 8px" : null,
          }}
        >
          {this.props.items.map((item, index) => {
            const message =
              typeof item.message === "object"
                ? item.message
                : { text: item.message };
            return (
              <li key={item + index}>
                <div className="img-container">
                  <img
                    src={item.image}
                    alt={
                      item.alt
                        ? intl.formatMessage({
                            id: item.alt ? item.alt : item.message,
                            defaultMessage: item.alt ? item.alt : item.message,
                            description: "",
                          })
                        : ""
                    }
                  />
                </div>
                <div className="tip">
                  <RichText {...message} />
                </div>
              </li>
            );
          })}
        </ul>
        {this.props.caption ? (
          <p className="caption">
            <RichText text={this.props.caption} />
          </p>
        ) : null}
      </div>
    );
  }
}

TakeawayMessagesBase.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  items: PropTypes.array.isRequired,
  heading: PropTypes.string.isRequired,
  className: PropTypes.string,
};

TakeawayMessagesBase.defaultProps = {
  className: "takeawayMessages",
};

export const TakeawayMessages = injectIntl(TakeawayMessagesBase);
